import { fetchOrderById, makeSelectOrderById } from 'logic/orders'
import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import Link from 'next/link'
import { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

class RetryLink extends Component {

  componentDidMount () {
    if (!this.props.paymentData.is_order) return
    localStorage.removeItem('ttp')
    localStorage.removeItem('ttpv')
    localStorage.removeItem('ttpc')

    this.props.actions.fetchOrderById(this.props.paymentData.payable_object_ext_id)
  }

  getVoucherRetryLink = ({ is_donation }) => is_donation
    ? `/${this.props.odn}/donate`
    : `/${this.props.odn}/voucher`

  getRetryLink = ({ payable_object_ext_id, is_order, is_donation }) => {
    if (payable_object_ext_id.includes('ord4_')) return `/${this.props.odn}/goods`
    if (is_order) return `/${this.props.odn}/b/${this.props.order && this.props.order.event_date_ids && this.props.order.event_date_ids[0]}/checkout?p=1`
    return this.getVoucherRetryLink({ is_donation })
  }

  render () {
    return (    
      <Link href={this.getRetryLink(this.props.paymentData || {})}>
        <Button color="primary">
          { this.props.backToBasket
            ? <FormattedMessage {...messages.backToBasket} />
            : <FormattedMessage {...messages.tryAgain} />
          }
        </Button>
      </Link>
    )
  }

}


const mapStateToProps = createStructuredSelector({
  order: makeSelectOrderById(props => props.paymentData.payable_object_ext_id),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchOrderById,
  }, dispatch)
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(RetryLink);
